export const MailingContext = 'slMailing_container_context';
export const StaticPagesContext = 'slStaticPages_container_context';
export const ConnectAccountContext = 'slConnectAccount_container_context';
export const EmailNotificationContext = 'slEmailNotification_container_context';
